import { NotificationManager } from '@sravni/react-design-system';

import { BASE_TIMEOUT } from 'constants/apiTimeout';

// забрать из NotificationsProps когда ДС пофиксят типы https://sravni-corp.atlassian.net/browse/OS-6806
interface IShowNotification {
  message?: string;
  title?: string;
  subtitle?: string;
  type?: 'info' | 'success' | 'warning' | 'error';
  timeout?: number;
  closable?: boolean;
}

export const showNotification = ({
  message = '',
  title = '',
  subtitle = '',
  type = 'error',
  timeout = BASE_TIMEOUT,
  closable = true,
}: IShowNotification) => {
  NotificationManager.show({ title, subtitle, message, timeout, type, closable });
};
